var _defs, _path, _path2, _path3, _rect, _rect2, _rect3, _line, _circle, _line2, _circle2, _line3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path4, _path5, _path6, _rect20, _rect21, _rect22, _rect23, _rect24, _line4, _line5, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecorationCity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 607.291 99.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\t\t\t.cls-1{fill:#ff9696;}\r\n\t\t\t.cls-1,.cls-2,.cls-3,.cls-5,.cls-7,.cls-8{stroke:#cf2525;stroke-linecap:round;stroke-linejoin:round;}\r\n\t\t\t.cls-2{fill:#fff;}\r\n\t\t\t.cls-3,.cls-5,.cls-7,.cls-8{fill:none;}\r\n\t\t\t.cls-4{opacity:0.25;}\r\n\t\t\t.cls-5{stroke-width:0.477px;}\r\n\t\t\t.cls-6{opacity:0.5;}\r\n\t\t\t.cls-7{stroke-width:0.558px;}\r\n\t\t\t.cls-8{stroke-width:0.434px;}\r\n\t\t"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "decoraton-city") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.4,78.647a7.681,7.681,0,0,0-7.681,7.681v11.9h15.361v-11.9A7.681,7.681,0,0,0,106.4,78.647Z",
    transform: "translate(0.5 0.217)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.028,88.165a3.948,3.948,0,0,0-3.948,3.948v6.117h7.9V92.112A3.948,3.948,0,0,0,118.028,88.165Z",
    transform: "translate(0.5 0.217)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.772,88.165a3.948,3.948,0,0,0-3.948,3.948v6.117h7.9V92.112A3.948,3.948,0,0,0,94.772,88.165Z",
    transform: "translate(0.5 0.217)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 110.847,
    y: 66.031,
    width: 58.25,
    height: 32.416
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158,
    y: 66.031,
    width: 11.098,
    height: 32.508
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.597,
    y: 79.489,
    width: 11.375,
    height: 19.049
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.5,
    y1: 98.538,
    x2: 606.791,
    y2: 98.538
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 458.322,
    cy: 81.322,
    r: 8.38
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 458.322,
    y1: 98.446,
    x2: 458.322,
    y2: 86.782
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 437.197,
    cy: 84.711,
    r: 6.722
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 437.197,
    y1: 98.446,
    x2: 437.197,
    y2: 89.09
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.931,
    y: 73.364,
    width: 5.667,
    height: 5.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 116.931,
    y: 73.364,
    width: 5.667,
    height: 5.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 552.832,
    y: 40.968,
    width: 21.843,
    height: 57.479
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 574.675,
    y: 40.968,
    width: 6.206,
    height: 57.479
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 557.546,
    y: 46.697,
    width: 12.414,
    height: 51.749
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 560.261,
    y: 84.864,
    width: 6.984,
    height: 13.583
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 561.624,
    y: 37.383,
    width: 4.5,
    height: 3.585
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 566.124,
    y: 37.383,
    width: 4.018,
    height: 3.585
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 472.791,
    y: 78.864,
    width: 57.667,
    height: 19.583
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 530.457,
    y: 78.864,
    width: 8.75,
    height: 19.583
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 480.922,
    y: 82.834,
    width: 6,
    height: 6.729
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 492.723,
    y: 82.834,
    width: 6,
    height: 6.729
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 504.525,
    y: 82.834,
    width: 6,
    height: 6.729
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 516.326,
    y: 82.834,
    width: 6,
    height: 6.729
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 477.944,
    y: 74.376,
    width: 47.361,
    height: 4.488
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 525.304,
    y: 74.376,
    width: 6.476,
    height: 4.488
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.3,78.647a7.681,7.681,0,0,0-7.681,7.681v11.9H187.98v-11.9A7.681,7.681,0,0,0,180.3,78.647Z",
    transform: "translate(0.5 0.217)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.927,88.165a3.947,3.947,0,0,0-3.948,3.948v6.117h7.9V92.112A3.948,3.948,0,0,0,191.927,88.165Z",
    transform: "translate(0.5 0.217)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M168.671,88.165a3.948,3.948,0,0,0-3.948,3.948v6.117h7.9V92.112A3.948,3.948,0,0,0,168.671,88.165Z",
    transform: "translate(0.5 0.217)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.457,
    y: 86.655,
    width: 11.333,
    height: 11.792
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.124,
    y: 78.864,
    width: 7.667,
    height: 19.583
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.791,
    y: 78.864,
    width: 11.333,
    height: 19.583
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.957,
    y: 86.655,
    width: 11.333,
    height: 11.792
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.291,
    y: 86.655,
    width: 6.874,
    height: 11.792
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 32.624,
    y1: 82.655,
    x2: 32.624,
    y2: 94.655
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.291,
    y1: 82.655,
    x2: 36.291,
    y2: 94.655
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.509,63.382h15.32S24.169,55.5,16.509,63.382Z",
    transform: "translate(0.5 0.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.016,63.382h6.508S17.269,60.036,14.016,63.382Z",
    transform: "translate(0.5 0.217)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M449.325,47.966h16.588S457.62,39.435,449.325,47.966Z",
    transform: "translate(0.5 0.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M458.924,47.966h16.588S467.218,39.435,458.924,47.966Z",
    transform: "translate(0.5 0.217)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M574.118,2.949h12.9S580.568-3.686,574.118,2.949Z",
    transform: "translate(0.5 0.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M581.432,2.949h9.118S585.991-1.741,581.432,2.949Z",
    transform: "translate(0.5 0.217)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorationCity);
export default __webpack_public_path__ + "static/media/decoration-city.7ee0fe2705516c19d49d941a499bcf5d.svg";
export { ForwardRef as ReactComponent };